// extracted by mini-css-extract-plugin
export default {"problems":"region-problems_problems__8O6cw","create":"region-problems_create__ZEOGq","type":"region-problems_type__ka7xA","problem":"region-problems_problem__y+OJ7"};